import AppleAndBooksIconElem from './component.jsx'
export default AppleAndBooksIconElem
